import React, { useContext } from 'react';

import UserStore from 'stores/UserStore';
import PaymentStore from 'stores/PaymentStore';


export const initialStoreValues = {
  UserStore,
  PaymentStore,
};

const StoreContext = React.createContext();

export const useStores = () => useContext(StoreContext);

export default StoreContext;
